import { useTranslation } from 'react-i18next';
import { EyeIcon } from '@heroicons/react/24/outline';

import IconButton from '@/components/ui/custom/buttons/IconButton';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';

type Props = {
  uploading?: boolean;
  url: string;
};

export default function ViewResourceButton(props: Props) {
  const [t] = useTranslation('translation', {
    keyPrefix: 'common',
  });

  const { url, uploading } = props;

  return (
    <Tooltip
      text={t('see')}
      className="h-fit"
      classNameContainer="flex items-center"
    >
      <IconButton
        href={url}
        disabled={uploading}
        testId="viewResourceButton"
        className="text-primary flex-row-reverse gap-1 font-500"
        color="custom"
        icon={<EyeIcon className="w-4 h-4 text-primary" />}
      />
    </Tooltip>
  );
}
